import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio",
  "use": "icon-radio-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\" \" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio\">\n<g id=\"icon-radio_Frame 18\">\n<circle id=\"icon-radio_Ellipse 55\" cx=\"8\" cy=\"8\" r=\"6.5\" fill=\"white\" stroke=\"#606B83\" />\n<circle id=\"icon-radio_Ellipse 60\" cx=\"8\" cy=\"8\" r=\"4\" fill=\"#606B83\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol